import { render, staticRenderFns } from "./BlockType3Grid.vue?vue&type=template&id=07dc36af&scoped=true"
import script from "./BlockType3Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType3Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType3Grid.vue?vue&type=style&index=0&id=07dc36af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc36af",
  null
  
)

export default component.exports